/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Login } from './components/Login'
// import { ForgotPassword } from './components/ForgotPassword'
// import { ResetPassword } from './components/ResetPassword'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import clsx from 'clsx'
import logo from '../../../_metronic/assets/image/trr_logo.svg'

const AuthPage = () => {
  const navigate = useNavigate()
  const STATE_LOGIN = 'LOGIN'
  const STATE_FORGOT = 'FORGOT'
  // const STATE_RESET = 'RESET'
  const [authState, setAuthState] = useState(STATE_LOGIN)
  const year = new Date().getFullYear()
  const [loginSuccess, setLoginSuccess] = useState(false); // Manage login state
  const [animateLogo, setAnimateLogo] = useState(false); // Manage login state
  const authPassed = () => {
    setLoginSuccess(true);
    setTimeout(()=>{setAnimateLogo(true);}, 1000)
  }
  useEffect(() => {
    document.body.classList.add('bg-body')
    return () => {
      document.body.classList.remove('bg-body')
    }
  }, [])

  const Outlet = () => {
    const handleChildData = (data: string) => {
      setAuthState(data)
    }

    // if (authState === STATE_FORGOT) return <ForgotPassword authState={handleChildData} />
    return <Login authState={handleChildData} authPassed={authPassed}/>
  }

  useEffect(() => {
    const parallax = (event: MouseEvent) => {
      document.querySelectorAll<HTMLElement>('.mouse').forEach((shift) => {
        const positionAttr = shift.getAttribute('data-value')
        if (positionAttr) {
          const position = parseFloat(positionAttr)
          const x = (window.innerWidth - event.pageX * position) / 90
          const y = (window.innerHeight - event.pageY * position) / 90

          shift.style.transform = `translateX(${x}px) translateY(${y}px)`
          shift.style.textShadow = `${x}px ${y}px 20px rgba(0,0,0,0.05)`
        }
      })
    }
    document.addEventListener('mousemove', parallax)

    return () => {
      document.removeEventListener('mousemove', parallax)
    }
  }, [])

  return (
    <>
      <div className='d-flex auth-layout-wrapper authPage'>
        <div className={`authLogin ${loginSuccess ? 'fadeOut' : ''} ${animateLogo ? 'animate' : ''}`}>
          <h2>Sign In</h2>
          <span className='text-muted'>TRR iProforma Account</span>
          <div className={clsx('auth-outlet-wrapper')}>
            <Outlet />
          </div>
          <div className='copyright'>
            <span className=''> Copyright © 2017-{year} iProforma.com. All rights reserved. V.W1.17.8, V.S1.17.8 </span>
          </div>
        </div>
        <div className={`authDeco ${loginSuccess ? 'whiteBg' : ''}`}>
          <div
            className='d-flex bgi-position-center order-1 order-lg-2 login_background'
            id='aside'
          >
            <div className={`login_logo ${loginSuccess ? 'showLogo' : ''} ${animateLogo ? 'animate' : ''}`}>
              <div></div>
              <img alt='Logo' src={logo} />
            </div>
            <div className={`mouse_move ${loginSuccess ? 'animate' : ''}`}>
              <div id='img1' className='mouse' data-value='1'>
                <i className='ki-outline ki-key-square'></i>
              </div>
              <div id='img3' className='mouse' data-value='2.4'>
                <i className='ki-outline ki-document'></i>
              </div>
              <h2>The Roof Realty</h2>
              <div id='img2' className='mouse' data-value='-0.8'>
                <i className='ki-outline ki-message-text '></i>
              </div>
              <div id='img4' className='mouse' data-value='-1.4'>
                <i className='ki-outline ki-user-square'></i>
              </div>
              <div id='img5' className='mouse' data-value='3'>
                <i className='ki-outline ki-message-edit'></i>
              </div>
              <div id='img6' className='mouse' data-value='3.6'>
                <i className='ki-outline ki-file-up'></i>
              </div>
              <div id='img7' className='mouse' data-value='0.6'>
                <i className='ki-outline ki-graph-up '></i>
              </div>
              <div id='img8' className='mouse' data-value='-1.4'>
                <i className='ki-outline ki-receipt-square '></i>
              </div>
              <div id='img9' className='mouse' data-value='-3.2'>
                <i className='ki-outline ki-finance-calculator '></i>
              </div>
              <div id='img10' className='mouse' data-value='1.6'>
                <i className='ki-outline ki-financial-schedule'></i>
              </div>
              <div id='img11' className='mouse' data-value='1'>
                <i className='ki-outline ki-calendar '></i>
              </div>
              <div id='img12' className='mouse' data-value='-2.8'>
                <i className='ki-outline ki-message-question '></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export { AuthPage }
